import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderTracking from './pages/OrderTracking';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getInit, getProducts } from './features/slices';
import AboutUs from './pages/AboutUs';
import ContactForm from './pages/Contact';
import Disclaimer from './pages/Disclaimer';
import OrderTrackingForm from './pages/OrderTracking';
import FAQs from './pages/FAQs';
import IntelectualPropertyClaim from './pages/IntellectualPropertyClaim';
import PaymentMethods from './pages/PaymentMethods';
import Privacy from './pages/PrivacyPolicy';
import ReturnsRefundPolicy from './pages/ReturnsRefundPolicy';
import ShippingDelivery from './pages/ShippingDelivery';
import Terms from './pages/TermsOfService';


function App() {
  const { logo } = useSelector(state => state.shop);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getInit())
  }, []);
  useEffect(() => {
    // Set title
    const hostname = window.location.hostname.split('.')[0]; // lấy phần đầu nếu cần
    document.title = hostname.toUpperCase();

    // Set favicon
    const favicon = document.querySelector("link[rel~='icon']");
    if (logo) {
      favicon.href = logo; // ví dụ: "/anof/favicon.ico"
    }
  }, [logo]);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/shipping" element={<ShippingDelivery />} />
        <Route path="/returns" element={<ReturnsRefundPolicy />} />
        <Route path="/payment-methods" element={<PaymentMethods />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/intellectual-property" element={<IntelectualPropertyClaim />} />
        <Route path="/order-tracking" element={<OrderTrackingForm />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-tracking" element={<OrderTracking />} />
      </Routes>
      <Footer />
    </Router>
  )
};

export default App;
